module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_03.76785160.png";